// export const url = "https://154.53.52.188:446/api/"
// export const url = "http://localhost:3000/api/"
// export const url = "https://www.educacionlaboral.com.do:449/api/";
export const url = "https://www.educacionlaboral.com.do:446/api/";
